import {hashSha256} from 'app/utils/hash/hashSha256';

export async function loadFormAppJS(javaScriptPath: string, signal?: AbortSignal) {
    let jsContent: string | undefined;
    const pathHash = await hashSha256(javaScriptPath);
    if (signal?.aborted) {
        return;
    }

    const existingScript = document.getElementById(pathHash);
    if (!existingScript) {
        const response = await fetch(javaScriptPath);
        jsContent = await response.text();
        if (!response.ok) {
            throw new Error(`Failed to load ${javaScriptPath}`);
        }
    } else {
        existingScript.remove();
        jsContent = existingScript.textContent ?? undefined;
    }

    if (jsContent) {
        const script = document.createElement('script');
        script.dataset.superformApp = '';
        script.id = pathHash;
        script.textContent = jsContent;
        document.head.appendChild(script);

        return script;
    }
}
